import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './pages/Login';
import EventsList from './pages/EventsList';
import EventDetails from './pages/EventDetails';
import CandidatesList from './components/CandidatesList';
import ConsolidatedReport from './components/ConsolidatedReport';
import ReportDetails from './pages/ReportDetails';
import Category from './pages/Category';
import CategoryDetails from './pages/CategoryDetails';
import AssessmentCategoryCards from './components/AssessmentCategoryCards';
import AssigneeFeedbackList from './components/AssigneeFeedbackList';
import LessonContent from './components/LessonContent';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import NotAuthorized from './pages/NotAuthorized';

const AppRoot = () => {
    const navigate = useNavigate();

    React.useEffect(() => {
        const onAuthError = () => {
            toast.error('Session expired. Please login again.');
            navigate('/', { replace: true });
        };

        window.addEventListener('authError', onAuthError);
        window.addEventListener('loggedOut', onAuthError);

        return () => {
            window.removeEventListener('authError', onAuthError);
            window.removeEventListener('loggedOut', onAuthError);
        };
    }, [navigate]);

    return (
        <div>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/dashboard" element={<AdminRoute><EventsList /></AdminRoute>} />
                <Route path="/not-authorized" element={<NotAuthorized />} />
                <Route path="/event/:id/:name" element={<ProtectedRoute><EventDetails /></ProtectedRoute>} />
                <Route path="/candidates/:id" element={<ProtectedRoute><CandidatesList /></ProtectedRoute>} />
                <Route path="/consolidated/:id" element={<ProtectedRoute><ConsolidatedReport /></ProtectedRoute>} />
                <Route path="/reports/:id" element={<ProtectedRoute><ReportDetails /></ProtectedRoute>} />
                <Route path="/categories" element={<ProtectedRoute><Category /></ProtectedRoute>} />
                <Route path="/categories/:id/:name" element={<ProtectedRoute><CategoryDetails /></ProtectedRoute>} />
                <Route path="/AssessmentCategoryCards" element={<ProtectedRoute><AssessmentCategoryCards /></ProtectedRoute>} />
                <Route path="/AssigneeFeedbackList" element={<ProtectedRoute><AssigneeFeedbackList /></ProtectedRoute>} />
                <Route path="/lessoncontent" element={<ProtectedRoute><LessonContent /></ProtectedRoute>} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <ToastContainer />
        </div>
    );
};

const App = () => (
    <Router>
        <AppRoot />
    </Router>
);

export default App;
